import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const PasteIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M8.92 4.08H10.48V5.64H8.92V4.08ZM11.62 4.08H13.18V5.64H11.62V4.08ZM14.32 4.08H15.88V5.64H14.32V4.08ZM17.02 4.08H18.58V5.64H17.02V4.08ZM17.02 6.78H18.58V8.34H17.02V6.78ZM5.42 19.84V7.48H15.08V19.84H5.42ZM6.98 18.28H13.52V9.04H6.98V18.28ZM17.02 9.48H18.58V11.04H17.02V9.48ZM17.02 12.18H18.58V13.74H17.02V12.18ZM17.02 14.88H18.58V16.44H17.02V14.88Z" />
    </SvgIcon>
  );
});
